import Service from './service';
import { AxiosResponse } from 'axios';
import { User } from '../interfaces/user';

const Config = require('Config');

class UserService extends Service {
  constructor() {
    super(Config.userServiceUrl);
  }

  async getUser(email, skipLogout = false): Promise<User> {
    this.skipLogout = skipLogout;
    const response: AxiosResponse = await this.axios.get(`user/${email}`);
    if (response.status !== 200) {
      throw new Error();
    }
    return response.data;
  }

  async patchUser(email: string, data: any): Promise<any> {
    const response: AxiosResponse = await this.axios.patch(`user/${email}`, data);
    if (response.status !== 200) {
      throw new Error();
    }
    return response.data;
  }

  async deleteUser(email: string) {
    const response: AxiosResponse = await this.axios.delete(`user/${email}`);
    if (response.status != 200) {
      throw new Error();
    }
    return response.data;
  }
}

export default new UserService();
